import { SxProps, Theme } from "@mui/material";

/** Shared credit cell box (balance & totalCreditsSinceStart columns) */
export const creditBoxSx: SxProps<Theme> = {
  display: "flex",
  flexDirection: "column",
  gap: "3px",
  width: "100%",
};

/** Bold small text inside credit cells */
export const creditLabelStyle: React.CSSProperties = {
  fontWeight: 600,
  fontSize: "0.85rem",
};

/** Dimmed dash shown when no pending credits */
export const noPendingStyle: React.CSSProperties = {
  color: "rgba(0,0,0,0.38)",
};

/** Pending-pack chip (extra column) */
export const pendingChipSx: SxProps<Theme> = {
  backgroundColor: "#e3f2fd",
  color: "#1565c0",
  fontWeight: 600,
};

/** LinearProgress base styles — bar color is injected dynamically */
export const creditProgressSx = (barColor: string): SxProps<Theme> => ({
  height: 4,
  borderRadius: 2,
  backgroundColor: "#eee",
  "& .MuiLinearProgress-bar": { backgroundColor: barColor },
});
